var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-template',{attrs:{"loading":_vm.loading,"search-config":_vm.searchConfig,"total":_vm.total,"current-page":_vm.currentPage,"table-data":_vm.tableData,"table-config":_vm.tableConfig},on:{"onSearch":_vm.onSearch,"onChangePage":_vm.changeCurrentPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }